module.exports = __webpack_public_path__ + "img/no_result.2209c2fd.png";